import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrModule } from 'ngx-toastr';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TokenService } from './shared/services/token.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DatePipe } from '@angular/common';
import { ExcelService } from './shared/services/excel.service';
import { HelperService } from './shared/services/helper.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { JwtInterceptor } from './shared/jwt.interceptor';
import { AuthModule } from './auth/auth.module';
import { AppConfigService } from './shared/services/app-config.service';

export function initializeApp(configService: AppConfigService) {
  return async (): Promise<void> => {
    await configService.load();
    // await configService.loadVersion();
  };
}

export function jwtOptionsFactory(tokenService: TokenService, appConfig: AppConfigService) {
  return {
    tokenGetter: () => tokenService.token,
    allowedDomains: appConfig.allowedDomains || [],
    disallowedRoutes: [], // you can add if needed
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,

    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [TokenService, AppConfigService],
      },
    }),

    AngularSvgIconModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      closeButton: true,
      positionClass: 'toast-top-center',
    }),
    NgSelectModule,
    AuthModule,
    FontAwesomeModule,
    NgxSpinnerModule,
  ],
  providers: [
    DatePipe,
    ExcelService,
    HelperService,

    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService],
      multi: true,
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }